import { render, staticRenderFns } from "./VideoItems3Template.vue?vue&type=template&id=1d734da3"
import script from "./VideoItems3Template.vue?vue&type=script&lang=js"
export * from "./VideoItems3Template.vue?vue&type=script&lang=js"
import style0 from "./VideoItems3Template.vue?vue&type=style&index=0&id=1d734da3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports